import { render } from "./advtiserinfo.vue?vue&type=template&id=497234cc&scoped=true"
import script from "./advtiserinfo.vue?vue&type=script&lang=js"
export * from "./advtiserinfo.vue?vue&type=script&lang=js"

import "./advtiserinfo.vue?vue&type=style&index=0&id=497234cc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497234cc"]])

export default __exports__